import * as React from "react";
import User from "../../../../../model/user/User";
import {Option} from "ts-option";
import {getUser} from "../../../../../store/view/user";
import {connect} from "react-redux";
import {RootState} from "../../../../../store/reducer/root/RootState";

interface IPresenterProps {
	/**
	 * User Id
	 */
	userId: string;
}

interface IReduxProps {
	/**
	 * User
	 */
	user: Option<User>;
}

type PresenterProps = IPresenterProps & IReduxProps;

class UserPresenterComponent extends React.PureComponent<PresenterProps> {
	render() {
		return (
			<div>
				{this.props.user.map(u => u.getDisplayName()).getOrElse(`Not found: ${this.props.userId}`)}
			</div>
		);
	}
}

function mapStateToProps(state: RootState, props: IPresenterProps) {
	return {
		user: getUser(props.userId),
	}
}

export default connect<IReduxProps, null, IPresenterProps>(mapStateToProps)(UserPresenterComponent);